module.exports = __webpack_public_path__ + "media/images/dot-primary-be1733a487e61ca7f66bb6aa23b135c2.svg";